<template>
    <SwitchGroup as="div" class="flex items-center">
        <SwitchLabel v-if="$slots.left" as="span" class="mr-3">
            <slot name="left" />
        </SwitchLabel>
        <Switch
            v-model="enabled"
            :style="`background-color: ${enabled ? props.enabledColor : props.disabledColor}`"
            class="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden"
        >
            <span
                aria-hidden="true"
                :class="[
                    enabled ? 'translate-x-5' : 'translate-x-0',
                    'bg-text-base pointer-events-none inline-block h-5 w-5 transform rounded-full shadow-xs ring-0 transition duration-200 ease-in-out',
                ]"
            />
        </Switch>
        <SwitchLabel as="span" class="ml-3">
            <slot />
        </SwitchLabel>
    </SwitchGroup>
</template>

<script setup>
import { ref, watch } from 'vue'
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'
import tailwind from '@/lib/tailwind'

const props = defineProps({
    modelValue: { type: Boolean, default: true },
    enabledColor: { type: String, default: tailwind.theme.color.brand.base },
    disabledColor: { type: String, default: tailwind.theme.color.button.dark.lighter },
})
const enabled = ref(props.modelValue)
const emits = defineEmits(['update:modelValue'])

watch(
    () => props.modelValue,
    (value) => {
        enabled.value = value
    }
)

watch(
    () => enabled.value,
    () => {
        emits('update:modelValue', enabled.value)
    }
)
</script>
